import { mapState } from 'vuex';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import listMixin from '@/components/niotaClassic/listMixin';
import { isCopyToClipboardSupported, copyToClipboard } from '../../../utils/vuex';
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'NiotaClassicDevicetypesLinkedDevicesList',
  mixins: [listMixin],
  props: {
    deviceTypeId: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      lastSearch: '',
      deviceUpdateDialog: false,
      deviceSingleUpdateDialog: false,
      deleteFromActility: false,
      isActility: false,
      editedItem: null,
      deviceTypes: [],
      applications: [],
      selectedRows: [],
      tableOptions: defaultTableOptions,
      tableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
      }
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    tableHeaders() {
      return [{
        text: this.$i18n_t('NiotaClassic.Common.table.id'),
        value: 'id',
        align: 'right'
      }, {
        text: this.$i18n_t('NiotaClassic.Common.table.title'),
        value: 'title'
      }, {
        text: this.$i18n_t('NiotaClassic.Common.table.eui'),
        value: 'eui'
      }, {
        text: this.$i18n_t('NiotaClassic.DeviceTypes.table.originator'),
        value: 'originator_title'
      }, {
        text: this.$i18n_t('NiotaClassic.Common.table.createdAt'),
        value: 'createdAt'
      }, ...(this.isIotHubManager ? [{
        value: 'actions',
        width: '80px',
        sortable: false
      }] : [])];
    }
  },
  mounted() {
    this.fetchList(true);
    this.deviceTypeFetchPlain();
    this.applicationsFetchPlain();
  },
  methods: {
    editDevice(item) {
      this.editedItem = cloneDeep(item);
      this.toggleEditDialog();
    },
    showDeletePrompt(item) {
      this.selectedItem = cloneDeep(item);
      this.isActility = (get(this.selectedItem, 'originator.type') || '').toLowerCase() === 'actility';
      this.deletePrompt = true;
    },
    /** closeDeletePrompt in listMixin */
    deleteFromRemote(remove) {
      this.deleteFromActility = remove;
    },
    deleteDevice() {
      let deletePromise = null;
      if (this.deleteFromActility) {
        deletePromise = NiotaClassicApiService.deviceDeleteFromActility(this.selectedItem.id);
      } else {
        deletePromise = NiotaClassicApiService.deviceDelete(this.selectedItem);
      }
      deletePromise.then(() => {
        this.selectedItem == null;
        this.$snack(this.$i18n_t('NiotaClassic.Applications.snacks.deviceDeleteSuccess'), 'success');
        this.refreshList();
      }).catch(() => {
        this.$snack(this.$i18n_t('NiotaClassic.Applications.snacks.deviceDeleteFailed'), 'error');
      }).finally(() => {
        this.deletePrompt = false;
      });
    },
    toggleEditDialog() {
      this.deviceSingleUpdateDialog = !this.deviceSingleUpdateDialog;
    },
    toggleEditAllDialog() {
      this.deviceUpdateDialog = !this.deviceUpdateDialog;
    },
    rowSelectUpdate(rows) {
      this.selectedRows = rows;
    },
    refreshList() {
      this.selectedRows = [];
      this.fetchList(true);
    },
    isCopySupported() {
      return isCopyToClipboardSupported();
    },
    copyToClipboard(event, eui) {
      event.stopPropagation();
      copyToClipboard(eui);
    },
    viewDevice(item) {
      this.$router.push({
        path: `/niota-classic/devices/${item.id}/details`
      });
    },
    deviceTypeFetchPlain() {
      NiotaClassicApiService.deviceTypeFetchPlain().then(res => {
        this.deviceTypes = res.data.devicetypes;
      }).catch(() => {
        this.deviceTypes = [];
        this.$snack(this.$i18n_t('NiotaClassic.Applications.form.errorFindingDeviceTypes'), 'error');
      });
    },
    applicationsFetchPlain() {
      NiotaClassicApiService.applicationsFetchPlain().then(res => {
        this.applications = res.data.applications;
      }).catch(() => {
        this.applications = [];
        this.$snack(this.$i18n_t('NiotaClassic.Applications.form.errorFindingApplications'), 'error');
      });
    },
    fetchList(fromStart) {
      if (this.isFetching) {
        return;
      }
      this.isFetching = true;
      const trimmedSearch = (this.searchItem || '').trim();
      if (this.lastSearch !== trimmedSearch) {
        this.lastSearch = trimmedSearch;
        this.tableOptions = defaultTableOptions;
      }
      const tableOptions = fromStart ? {
        ...this.tableOptions,
        page: 1
      } : this.tableOptions;
      const {
        sortBy,
        sortDesc,
        page,
        itemsPerPage
      } = tableOptions;
      const sortItem = sortBy && sortBy.length ? sortBy[0] : 'createdAt';
      const doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      const sortDirection = doSortDesc ? 'DESC' : 'ASC';
      const usedPage = page || 1;
      const usedItemsPerPage = itemsPerPage ? itemsPerPage : defaultItemsPerPage;
      NiotaClassicApiService.getDeviceTypeDevices(this.deviceTypeId, trimmedSearch, usedPage, usedItemsPerPage, sortItem, sortDirection).then(res => {
        this.list = res.data.devices;
        this.serverItemsLength = res.pagination.itemCount;
      }).catch(() => {
        this.$snack(this.$i18n_t('NiotaClassic.DeviceTypes.snacks.fetchFailed'), 'error');
      }).finally(() => {
        this.isFetching = false;
      });
    }
  }
};